import type { UseQueryResult } from '@tanstack/react-query';
import {
	QUERY,
	type QueryOperation,
	type QueryOptionsWithoutQueryKeyAndFn,
	type SuspenseQueryOptionsWithoutQueryKeyAndFn,
	useQueryOperation,
	useSuspenseQueryOperation
} from 'api/Query';
import type { ServiceCallError } from 'api/ServiceCallError';
import type { ServerOptions } from 'typedefs/ServerOptions';

/** Returns the given server option query result. */
export function useServerOption<OPTION extends keyof ServerOptions, TData = ServerOptions[OPTION]>(
	option: OPTION,
	queryOptions?: QueryOptionsWithoutQueryKeyAndFn<ServerOptions[OPTION], TData>
): UseQueryResult<TData, ServiceCallError> {
	const singleProjectOption = QUERY.getSingleServerOption(option) as unknown as QueryOperation<ServerOptions[OPTION]>;
	return useQueryOperation(singleProjectOption, queryOptions);
}

/** Returns the given server option. This component might suspend. */
export function useSuspenseServerOption<OPTION extends keyof ServerOptions>(
	option: OPTION,
	queryOptions?: SuspenseQueryOptionsWithoutQueryKeyAndFn<ServerOptions[OPTION]>
): ServerOptions[OPTION] {
	return useSuspenseQueryOperation(
		QUERY.getSingleServerOption(option) as unknown as QueryOperation<ServerOptions[OPTION]>,
		queryOptions
	);
}
